import * as React from 'react';
import {withStyles, WithStyles, StyleRules} from '@material-ui/core/styles';
import {Theme} from '@material-ui/core/styles';
import {
  Typography,
  TextField,
} from '@material-ui/core';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  sectionTitle: {
    fontSize: '1rem'
  },
  subheading: {
    marginBottom: 15
  },
  instructions: {
    padding: 15
  },
  formArea: {
    paddingRight: 15
  },
  formField: {
    width: '100%',
    margin: 5
  },
  fieldRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  itemDelete: {
    fontSize: '0.80rem',
    width: 45,
    height: 45
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  field: any;
  onCustomMessagesChange: (newCustomMessages: any) => void;
}

// We will kepp internal state to give more customMessages to the consumers, but we will always defer to the data coming from the props.
type State = {
  customMessages: any;
};

class CustomMessagesView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      customMessages: this.props.field.customMessages || []
    };
  }

  handleAttributeChange = (attribute: string) => (evt: any) => {
    const {customMessages} = this.state;
    customMessages[attribute] = evt.target.value;
    this.setState({customMessages});
    if (this.props.onCustomMessagesChange) {
      this.props.onCustomMessagesChange(customMessages);
    }
  };

  render() {
    const {classes}: {classes: any} = this.props;
    const {customMessages} = this.state;
    const {field} = this.props;

    // Just return if there are no custom messages
    if (field.type == 'VersionedDocument' || field.type == 'Boolean') {
      return null;
    }

    return (
      <div className={classes.container}>
        <Typography className={classes.subheading} variant="subtitle1">
          Custom Messages
        </Typography>
        <div className={classes.formArea}>
          {field.type == 'Text' && (
            <TextField
              className={classes.formField}
              id="invalidRegex"
              name="invalidRegex"
              value={customMessages.invalidRegex || ''}
              label="invalidRegex"
              onChange={this.handleAttributeChange('invalidRegex')}
              InputLabelProps={{
                shrink: true
              }}
            />
          )}
          {field.type == 'Text' && (
            <TextField
              className={classes.formField}
              id="invalidMinLength"
              name="invalidMinLength"
              value={customMessages.invalidMinLength || ''}
              label="invalidMinLength"
              onChange={this.handleAttributeChange('invalidMinLength')}
              InputLabelProps={{
                shrink: true
              }}
            />
          )}
          {field.type == 'Text' && (
            <TextField
              className={classes.formField}
              id="invalidMaxLength"
              name="invalidMaxLength"
              value={customMessages.invalidMaxLength || ''}
              label="invalidMaxLength"
              onChange={this.handleAttributeChange('invalidMaxLength')}
              InputLabelProps={{
                shrink: true
              }}
            />
          )}
          {(field.type == 'Number' ||
            field.type == 'Numeric' ||
            field.type == 'Currency') && (
            <TextField
              className={classes.formField}
              id="invalidMinValue"
              name="invalidMinValue"
              value={customMessages.invalidMinValue || ''}
              label="invalidMinValue"
              onChange={this.handleAttributeChange('invalidMinValue')}
              InputLabelProps={{
                shrink: true
              }}
            />
          )}
          {(field.type == 'Number' ||
            field.type == 'Numeric' ||
            field.type == 'Currency') && (
            <TextField
              className={classes.formField}
              id="invalidMaxValue"
              name="invalidMaxValue"
              value={customMessages.invalidMaxValue || ''}
              label="invalidMaxValue"
              onChange={this.handleAttributeChange('invalidMaxValue')}
              InputLabelProps={{
                shrink: true
              }}
            />
          )}
          {(field.type == 'Date' || field.type == 'DateTime') && (
            <TextField
              className={classes.formField}
              id="invalidMinDate"
              name="invalidMinDate"
              value={customMessages.invalidMinDate || ''}
              label="invalidMinDate"
              onChange={this.handleAttributeChange('invalidMinDate')}
              InputLabelProps={{
                shrink: true
              }}
            />
          )}
          {(field.type == 'Date' || field.type == 'DateTime') && (
            <TextField
              className={classes.formField}
              id="invalidMaxDate"
              name="invalidMaxDate"
              value={customMessages.invalidMaxDate || ''}
              label="invalidMaxDate"
              onChange={this.handleAttributeChange('invalidMaxDate')}
              InputLabelProps={{
                shrink: true
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CustomMessagesView);
